import Lottie from 'react-lottie';
import { Fade } from "react-awesome-reveal"
const defaultOptions = {
    loop: true,
    autoplay: true,
    rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice'
    }
};

export const ServiceSection = ({title,content, lottie})=>{
    return <div className="bg-dark1">
                <div className="container">
                    <div className="row py-5 align-items-center justify-content-center justify-content-lg-start ">
                        <div className="col-lg-4 col-8">
                            <Fade triggerOnce={true}>
                                <Lottie options={{...defaultOptions, animationData:lottie}}
                                    height={'100%'}
                                    width={'100%'}
                                />
                            </Fade>
                        </div>
                        <div className="col-lg-8 mt-lg-0 mt-3">
                            <Fade triggerOnce={true}>
                                <h3 className='text-primary stroke-animation'
                                    dangerouslySetInnerHTML={{
                                        __html: title
                                    }}
                                />
                            </Fade>
                            <Fade triggerOnce={true}>
                                <div className="text-white mt-3" dangerouslySetInnerHTML={{ __html: content }} />
                            </Fade>
                        </div>
                    </div>
                </div>
            </div>
}